// extracted by mini-css-extract-plugin
module.exports = {"nameInputWrap":"FirmwaresPage_nameInputWrap__1vBUr","nameInputIcon":"FirmwaresPage_nameInputIcon__FMi_K"};